module.exports = "../static/images/d65292.png";